import React, { Component } from "react";

class ConfirmationMessage extends Component {

    render() {
        return (
            <div className={"confirmation"} style={{display: this.props.isVisible ? "block" : "none"}}>
                <h1>Vielen Dank für Ihren kostenlosen Eintrag!</h1>

                <h2>Das müssen Sie jetzt noch tun:</h2>
                <p className={"notice"}>
                    Bitte prüfen Sie jetzt Ihr E-Mail Postfach. Aus Gründen der Datensicherheit haben wir Ihnen einen Verifizierunglink zugesendet. um die Echtheit ihrer E-Mail Adresse zu überprüfen.
                </p>
            </div>
        );
    }
}

export default ConfirmationMessage;
